import { hashState } from "./hash.js";
import type { InputFrame } from "./input.js";
import { createWorld, step, type WorldSetup, type WorldState } from "./world.js";

/** Laço da partida: guarda o estado atual e aplica um quadro de comandos por tick. */
export class Simulation {
  private current: WorldState;

  constructor(setupOrState: WorldSetup | WorldState) {
    this.current = "tick" in setupOrState ? structuredClone(setupOrState) : createWorld(setupOrState);
  }

  get state(): Readonly<WorldState> {
    return this.current;
  }

  get tick(): number {
    return this.current.tick;
  }

  step(inputs: InputFrame): WorldState {
    this.current = step(this.current, inputs);
    return this.current;
  }

  /** Cópia independente do estado, para reconciliação do cliente e testes. */
  snapshot(): WorldState {
    return structuredClone(this.current);
  }

  hash(): string {
    return hashState(this.current);
  }
}
